module.exports = __webpack_public_path__ + "images/944842cc8c72b2228aa17b75c15cf0e4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/language_alive.jpeg
// module id = 910
// module chunks = 0